$('.pdf-thumbnail').each(function () {
    $(this).on('load', function () {
        $(this).parent().addClass('hide-loader');
    })
})

$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

function addClassToEachElementFromArray(element, classes) {
    let counter = 0;
    $(element).each(function () {
        if (!$(this).parent().hasClass("link-list")) {
            if (counter >= classes.length) {
                counter = 0;
            }
            $(this).addClass(classes[counter++]);
        }
    });
}

const dot_styles = ['position-1', 'position-2', 'position-3', 'position-4'];
addClassToEachElementFromArray('.twi-image-container', dot_styles);

const li_styles = ['green', 'pink', 'blue', 'orange', 'yellow'];
addClassToEachElementFromArray('ol li, ul li', li_styles);

//Filter providers by region
$('select#location-filter').on('change', function () {
    var filter = $(this).val(),
        list = $(".provider");
    $(list).hide();
    if (filter == "All") {
        $(".provider").each(function (i) {
            $(this).show();
        });
    } else {
        $(".provider[data-custom-type='" + filter + "']").each(function (i) {
            $(this).show();
        });
    }
    $('.providers-map').trigger('initialize');
});

// Initialize providers map
$('.providers-map').each(function () {
    let map = L.map(this).setView([-41.29260796538415, 174.7768093624618], 13),
        markers = L.layerGroup().addTo(map);

    //Add tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    const markerColors = ['green', 'pink', 'blue', 'orange', 'yellow'];

    //Add markers
    $(this).on('initialize', function () {
        var maxLat, minLat, maxLng, minLng;
        //Clear old markers
        markers.clearLayers();

        let counter = 0;
        $('.providers-list .provider:visible').each(function () {
            if (!$(this).data('lat')) return;

            if (counter >= markerColors.length) {
                counter = 0;
            }

            let myIcon = L.icon({
                iconUrl: '_resources/themes/accesschoice/images/map-marker-' + markerColors[counter++] + '.svg',
                iconSize: [28, 28],
                iconAnchor: [18, 28],
                popupAnchor: [-3, 36],
                shadowSize: [68, 95],
                shadowAnchor: [18, 28]
            });

            L.marker([$(this).data('lat'), $(this).data('long')], {icon: myIcon})
                .bindPopup($(this).find('.text').html())
                .addTo(markers);
            //Keep track of min/max lat/lng
            if (!maxLat || $(this).data('lat') > maxLat) maxLat = $(this).data('lat');
            if (!minLat || $(this).data('lat') < minLat) minLat = $(this).data('lat');
            if (!maxLng || $(this).data('long') > maxLng) maxLng = $(this).data('long');
            if (!minLng || $(this).data('long') < minLng) minLng = $(this).data('long');
        });

        //Set bounding box
        map.fitBounds([
            [maxLat, maxLng],
            [minLat, minLng]
        ])

        //Make sure it's not too zoomed in
        if (map.getZoom() > 13) map.setZoom(13);
    }).trigger('initialize');
})

$('.large-title .twi-title, .large-title .title').each(function () {
    let text = $(this).text().split(" "),
        html = "";

    for (let i = 0; i < text.length; i++) {
        if (i === 0) {
            html += text[i];
        } else if (i === text.length - 1) {
            html += text[i];
        } else {
            html += " <span class='italics'>" + text[i] + "</span> ";
        }
    }
    $(this).html(html);
})

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$('#modal-btn').on('click', function(event) {
    event.preventDefault();
    let now = new Date();
    let time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    document.cookie = 'modal=closed' + '; expires=' + now.toUTCString() +'; path=/';
    $('body').removeClass('has-modal');
});

$(document).ready(function() {
    if (getCookie('modal') == 'closed') {
        $('body').removeClass('has-modal');
    }
});
